import { render, staticRenderFns } from "./CompanyEventList.vue?vue&type=template&id=c8900462&scoped=true"
import script from "./CompanyEventList.vue?vue&type=script&lang=js"
export * from "./CompanyEventList.vue?vue&type=script&lang=js"
import style0 from "./CompanyEventList.vue?vue&type=style&index=0&id=c8900462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8900462",
  null
  
)

export default component.exports